/**
 * Security utility functions for frontend
 */


/**
 * Validate file type to prevent malicious uploads
 */
export const validateFileType = (file: File): boolean => {
  const allowedTypes = ['application/pdf', 'text/plain'];
  const allowedExtensions = ['.pdf', '.txt'];
  
  // Check MIME type
  if (!allowedTypes.includes(file.type)) {
    return false;
  }
  
  // Check file extension
  const extension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
  if (!allowedExtensions.includes(extension)) {
    return false;
  }
  
  return true;
};

/**
 * Validate file size to prevent large file attacks
 */
export const validateFileSize = (file: File, maxSizeMB: number = 5): boolean => {
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  return file.size <= maxSizeBytes;
};

/**
 * Generate CSRF token for requests
 */
export const generateCSRFToken = (): string => {
  const array = new Uint8Array(32);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
};

